import React from 'react';
import { styled } from '@mui/material/styles';
import { chartContainerStyles } from '../styles/ChartStyles';

const StyledChartContainer = styled('div')(({ theme }) => chartContainerStyles(theme));

const ChartContainer = ({ children }) => {
  return <StyledChartContainer>{children}</StyledChartContainer>;
};

export default ChartContainer;